import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from 'app/app.module';
import { setAppConfig } from 'config/app-config';
import { GmsAppConfig } from 'config/app-config.interfaces';
import { environment } from 'environments/environment';
import { Amplify } from 'aws-amplify';

fetch('/assets/app-config.json')
  .then(response => response.json())
  .then((config: GmsAppConfig) => {
    setAppConfig(config);

  // Configure Amplify for AppSync Events with correct interface
  const eventsEndpoint = config?.amplify?.apiEndpoint;
  console.log('🎯 AppSync Events endpoint:', eventsEndpoint);

  if (eventsEndpoint) {
    Amplify.configure({
      API: {
        Events: {
          endpoint: eventsEndpoint,
          region: config?.amplify?.region,
          defaultAuthMode: 'lambda',
        }
      }
    });
  }


    // Set env to local storage for easy logging retrieval
    localStorage.setItem('environment', JSON.stringify(config.environment));
    if (config.environment !== 'prod') {
      // For now don't enable in prod
      window.dispatchEvent(new Event('TracingStart'));
    }

    if (!environment.production) {
      console.warn(
        `App is running under '${config.environment}' configuration. Endpoint configuration:`
      );
      console.table ? console.table(config.endpoints) : console.log(config.endpoints);
    }

    if (environment.production) {
      enableProdMode();
    }

    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .then(mod => {
        const injector = mod.injector;
        console.log('Bootstrapped:', mod.instance.constructor.name);
        console.log('Injector keys:', injector['_records'] ? Object.keys(injector['_records']) : injector);
})
      .catch(err => console.error(err));
  })
  .catch(err => console.error(err));
